/**
 * Calculates Estimated 1RM (e1RM) using the Brzycki formula.
 * Formula: Weight * (36 / (37 - Reps))
 */
export function calculateE1RM(weight: number, reps: number): number {
  if (reps <= 0) return 0;
  if (reps === 1) return weight;

  // Brzycki is generally accurate for reps up to 10-12
  const e1rm = weight * (36 / (37 - reps));
  return Math.round(e1rm * 10) / 10; // Round to 1 decimal place
}

/**
 * Calculates total volume for a set.
 */
export function calculateVolume(weight: number, reps: number): number {
  return weight * reps;
}

/**
 * Calculates progress delta between two values.
 */
export function calculateDelta(
  current: number,
  previous: number,
): {
  value: number;
  percentage: number;
} {
  if (previous <= 0) return { value: 0, percentage: 0 };
  const deltaValue = current - previous;
  const deltaPercentage = (deltaValue / previous) * 100;

  return {
    value: Math.round(deltaValue * 10) / 10,
    percentage: Math.round(deltaPercentage * 10) / 10,
  };
}
